module.exports = __webpack_public_path__ + "static/media/image17.37389fac.JPG";